import { logger } from '@/lib/logger';
import { createAtomics } from '@paypalcorp/atomic-events';
import {
  atomicsDomain,
  atomicsFlows,
  atomicsTasks,
  atomicsViewNames,
  policy,
} from './atomicConstants';

export let atomics: any;

export function setupAtomics(): void {
  atomics = createAtomics(
    {
      initialState: {
        domain: atomicsDomain,
        flow: atomicsFlows.guestAndSignup,
        task: atomicsTasks.reviewYourPayment,
        viewName: atomicsViewNames.reviewYourPayment,
      },
      policy: policy,
    },
    payload => {
      if (!(Array.isArray(payload) && payload.length > 0)) {
        return null;
      }

      payload.forEach(singleEvent => {
        if (singleEvent.type === 'metric') {
          const { metricId } = singleEvent.value;
          const metricPayload = {
            ...singleEvent.value,
            dimensions: {
              ...singleEvent.value.dimensions,
              client_app: 'weasley',
            },
            metricNamespace: metricId,
          };
          logger.atomicMetric(metricPayload);
        }
      });
    },
  );
}
